import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../../models/user.model';
import { PermissionHelper } from '../helpers/permission.helper';
import { MpsRoleHelper } from '../../../app/helpers/mps-role.helper';
import { globalRouteNames } from '../global-route-names';
import { MpsUserService } from '../../../mps/services/mps-user.service';

const hasPermission = (): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  const userService = inject(MpsUserService);
  const router = inject(Router);

  const allowedRoles = MpsRoleHelper.getAllRoleCodes();

  const mpsUser = userService.getUserSubject().getValue();
  if (!mpsUser) {
    return router.navigate([globalRouteNames.root]);
  }
  const authUser = new User(mpsUser);

  const isUserRoleAllowedForRoute = PermissionHelper.hasAnyRole(authUser, allowedRoles);
  return isUserRoleAllowedForRoute ? true : redirectByRole(authUser, router);
};

const redirectByRole = (authUser: User, router: Router): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  return router.navigate([globalRouteNames.root]);
};

export const canActivateHome: CanActivateFn = () => hasPermission();
export const canMatchHome: CanMatchFn = () => hasPermission();
